var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * 自定义查询组件 - 真实接口实现（对接后端）
 *
 * 说明：这里只实现已对接后端的方法，未实现的方法由 runtime 合并时自动回退到内置 mock。
 *   getMainTables(appId)     -> /bsp-com/com/statis/getStatisTables   获取可选主表
 *   getTableFields(tableName)  -> /bsp-ops/ops/res/field/getFieldAllData 获取主表字段
 *
 * 组件后续将单独打包发布，接口地址内聚在组件内部（不依赖项目 path 配置）。
 * 接口沿用项目统一的 store postRequest（自动带 access_token，x-www-form-urlencoded），
 * 返回体约定为 { success, rows, msg }。
 */
import Qs from 'qs';
import { getStore } from '../runtime';
var kssAppId = ''; //发布组件需要去掉 只是用来测试
// 组件内置接口地址（自定义查询专用，随组件一起打包发布）
var API_URLS = {
  mainTables: '/bsp-com/com/statis/getStatisTables', // 获取可选主表
  // tableFields: '/bsp-ops/ops/res/field/getFieldAllData', // 获取主表字段全部字段
  tableFields: '/bsp-com/com/statis/getTableFields', // 获取主表字段 只展示自定义查询字段
  saveQueryTemplate: '/bsp-com/com/statis/saveQueryTemplate', // 保存/更新查询模板（模板名可不传）
  queryPageData: '/bsp-com/com/statis/getQueryPageData', // 执行查询，分页获取结果数据
  templatePage: '/bsp-com/com/statis/getQueryTemplatePage', // 分页获取历史查询模板
  deleteQueryTemplate: '/bsp-com/com/statis/deleteQueryTemplate', // 删除历史查询模板
  queryConfig: '/bsp-com/com/statis/getQueryConfig', // 获取自定义查询列表配置（执行/编辑回填）
  exportQueryData: '/bsp-com/com/statis/exportQueryData', // 导出查询结果 excel
  queryScript: '/bsp-com/com/statis/getQueryScript' // 获取查询脚本（标准sql / 调试sql）


  // 应用ID：优先取入参，其次取全局 serverConfig.APP_ID
};function resolveAppId(appId) {
  if (appId) {
    return kssAppId || appId;
  }
  return typeof serverConfig !== 'undefined' && serverConfig && serverConfig.APP_ID || '';
}

// 主表名 -> resId 映射（getFieldAllData 需要 resId，而组件仅按主表名回调 getTableFields）
var tableResIdMap = {};

// 从对象里按候选 key 顺序取第一个有值的字段（兼容后端字段命名差异）
function pick(obj, keys) {
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  for (var i = 0; i < keys.length; i++) {
    var v = obj[keys[i]];
    if (v !== undefined && v !== null && v !== '') {
      return v;
    }
  }
  return fallback;
}

function post(url, params) {
  return getStore().dispatch('postRequest', { url: url, params: params }).then(function (data) {
    if (data && data.success) {
      // 兼容两种返回：主表接口用 data，字段接口用 rows
      return data.rows || data.data || [];
    }
    return [];
  });
}

var realApi = {
  getMainTables: function getMainTables(appId) {
    return post(API_URLS.mainTables, { appId: kssAppId || appId || '' }).then(function (rows) {
      return rows.map(function (r) {
        var name = pick(r, ['tableName', 'resName', 'name']);
        var resId = pick(r, ['resId', 'id']);
        // 缓存主表名到 resId 的映射，供 getTableFields 使用
        if (name) {
          tableResIdMap[name] = resId || name;
        }
        return {
          name: name,
          label: pick(r, ['tableCname', 'resCname', 'label'], name),
          resId: resId || name
        };
      });
    });
  },
  getTableFields: function getTableFields(tableName) {
    var resId = tableResIdMap[tableName] || tableName;
    return post(API_URLS.tableFields, { resId: resId }).then(function (rows) {
      return rows.map(function (f) {
        var name = pick(f, ['fieldName', 'name']);
        return {
          name: name,
          label: pick(f, ['fieldCname', 'fieldComment', 'label'], name),
          code: name,
          fieldType: pick(f, ['fieldType', 'jdbcType', 'type']),
          dicName: pick(f, ['dicName']),
          // 扩展字段
          format: pick(f, ['format']),
          isDicMultiple: pick(f, ['isDicMultiple']),
          dicType: pick(f, ['dicType']),
          dicInfo: pick(f, ['dicInfo'])
        };
      });
    });
  },

  // 保存/更新查询模板；更新时传 id
  saveQueryTemplate: function saveQueryTemplate() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var body = {
      appId: resolveAppId(params.appId),
      queryJson: typeof params.queryJson === 'string' ? params.queryJson : JSON.stringify(params.queryJson || {})
    };
    if (params.templateName) {
      body.templateName = params.templateName;
    }
    // 模板描述
    if (params.remark !== undefined && params.remark !== null) {
      body.remark = params.remark;
    }
    // 查询条件拼接的中文内容
    if (params.queryCondition !== undefined && params.queryCondition !== null) {
      body.queryCondition = params.queryCondition;
    }
    if (params.id) {
      body.id = params.id;
    }
    return getStore().dispatch('postRequest', { url: API_URLS.saveQueryTemplate, params: body });
  },

  // 执行查询：分页拉取结果数据，返回 { columns, rows, total }
  executeQuery: function executeQuery() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var pageNo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

    var queryJson = payload.queryJson;
    var body = {
      appId: kssAppId || resolveAppId(payload.appId),
      queryJson: typeof queryJson === 'string' ? queryJson : JSON.stringify(queryJson || {}),
      pageNo: pageNo,
      pageSize: pageSize
      // 兼容从历史模板执行
    };if (payload.templateId) {
      body.id = payload.templateId;
      body.templateName = payload.templateName;
    }
    return getStore().dispatch('postRequest', { url: API_URLS.queryPageData, params: body }).then(function (data) {
      var rows = data && (data.rows || data.data) || [];
      // 列优先取后端返回的 header（字段元信息 { name,label,type,valueType,dicName }）
      // 字段存在字典 dicName 时，取值字段改用 <字段>Name（展示字典翻译后的值）
      var header = data && data.header;
      var columns = [];
      if (header && (typeof header === 'undefined' ? 'undefined' : _typeof(header)) === 'object') {
        columns = Object.keys(header).map(function (k) {
          var h = header[k] || {};
          var name = h.name || k;
          return {
            title: h.label || name,
            key: h.dicName ? name + 'Name' : name,
            // 透传字段扩展属性
            format: pick(h, ['format']),
            isDicMultiple: pick(h, ['isDicMultiple']),
            dicType: pick(h, ['dicType']),
            dicInfo: pick(h, ['dicInfo'])
          };
        });
      }
      // 兜底：header 缺失时，用配置的展示字段，其次从首行数据推断
      if (!columns.length) {
        columns = (payload.showFields || []).map(function (f) {
          return { title: f.label || f.name, key: f.name };
        });
      }
      if (!columns.length && rows.length) {
        columns = Object.keys(rows[0]).map(function (k) {
          return { title: k, key: k };
        });
      }
      return {
        columns: columns,
        rows: rows,
        success: data && data.success || false,
        total: data && data.total || 0,
        msg: data && data.msg || data && data.message || ''
      };
    });
  },

  // 分页获取历史查询模板，返回 { rows, total }
  getTemplatePage: function getTemplatePage() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var body = {
      appId: kssAppId || resolveAppId(params.appId),
      pageNo: params.pageNo || 1,
      pageSize: params.pageSize || 10,
      searchValue: params.searchValue || params.keyword || ''
    };
    console.log('getTemplatePage', body);
    // 组件按 keyword 搜索，接口参数为 templateName
    var templateName = params.templateName || params.keyword;
    if (templateName) {
      body.templateName = templateName;
    }
    if (params.tableId) {
      body.tableId = params.tableId;
    }
    return getStore().dispatch('postRequest', { url: API_URLS.templatePage, params: body }).then(function (data) {
      var list = data && (data.rows || data.data) || [];
      var rows = list.map(function (r) {
        return {
          id: pick(r, ['id']),
          name: pick(r, ['templateName', 'name']),
          templateName: pick(r, ['templateName', 'name']),
          description: pick(r, ['description', 'remark']),
          mainTableName: pick(r, ['tableCname', 'tableName', 'mainTableName']),
          queryCondition: pick(r, ['queryCondition']),
          queryConfig: pick(r, ['queryConfig', 'queryJson']),
          createTime: pick(r, ['createTime', 'addTime', 'updateTime'])
        };
      });
      return { rows: rows, total: data && data.total || 0 };
    });
  },

  // 删除历史查询模板
  deleteTemplate: function deleteTemplate(id, templateName) {
    var body = {
      appId: kssAppId || resolveAppId(),
      id: id || ''
    };
    if (templateName) {
      body.templateName = templateName;
    }
    return getStore().dispatch('postRequest', { url: API_URLS.deleteQueryTemplate, params: body });
  },

  // 获取自定义查询列表配置（历史模板执行/编辑时回填），返回 detail 对象或 null
  // 后端回显结构：{ tables:[{id,tableName,tableCname}], operators:[{value,label}],
  //   fieldsByTable:{ <tableId>:[{fieldName,fieldCname,fieldType,dicName}] },
  //   queryConfig:{ conditions:[{fieldName,op,value,relation}], showFields:[name] } }
  getTemplateDetail: function getTemplateDetail(id, templateName) {
    var body = {
      appId: kssAppId || resolveAppId(),
      id: id || ''
    };
    if (templateName) {
      body.templateName = templateName;
    }
    return getStore().dispatch('postRequest', { url: API_URLS.queryConfig, params: body }).then(function (data) {
      if (!data || !data.success) {
        return null;
      }
      var cfg = data.data || (Array.isArray(data.rows) ? data.rows[0] : data.rows) || {};

      // 已保存的查询（条件/表头字段），兼容 queryConfig 与旧 queryJson，字符串统一解析
      var queryConfig = cfg.queryConfig !== undefined ? cfg.queryConfig : cfg.queryJson;
      if (typeof queryConfig === 'string') {
        try {
          queryConfig = JSON.parse(queryConfig);
        } catch (e) {
          queryConfig = {};
        }
      }
      queryConfig = queryConfig || {};

      // 已选主表：取 tables[0]，兜底回退到 cfg/queryConfig 上的表名
      var tables = Array.isArray(cfg.tables) ? cfg.tables : [];
      var mainTable = tables[0] || {};
      var mainTableName = pick(mainTable, ['tableName', 'name']) || pick(cfg, ['tableName', 'mainTableName']) || pick(queryConfig, ['tableName']);
      var mainTableId = pick(mainTable, ['id', 'resId']);
      // 缓存主表名 -> resId，供 getTableFields 兜底取字段
      if (mainTableName && mainTableId) {
        tableResIdMap[mainTableName] = mainTableId;
      }

      // 主表字段：fieldsByTable 以表 id 为键，归一化成组件字段结构
      var fieldsByTable = cfg.fieldsByTable || {};
      var rawFields = mainTableId && fieldsByTable[mainTableId] || [];
      var fields = rawFields.map(function (f) {
        var name = pick(f, ['fieldName', 'name']);
        return {
          name: name,
          label: pick(f, ['fieldCname', 'fieldComment', 'label'], name),
          code: name,
          fieldType: pick(f, ['fieldType', 'jdbcType', 'type']),
          dicName: pick(f, ['dicName']),
          // 扩展字段
          format: pick(f, ['format']),
          isDicMultiple: pick(f, ['isDicMultiple']),
          dicType: pick(f, ['dicType']),
          dicInfo: pick(f, ['dicInfo'])
        };
      });

      // 查询条件：保留原始运算符与关系（relation: AND/OR）+ 扩展字段
      var conditions = (queryConfig.conditions || []).map(function (c) {
        return {
          fieldName: pick(c, ['fieldName', 'name']),
          op: pick(c, ['op', 'operator']),
          value: c.value !== undefined ? c.value : '',
          relation: pick(c, ['relation', 'logic'], 'and'),
          // 扩展字段
          format: pick(c, ['format']),
          isDicMultiple: pick(c, ['isDicMultiple']),
          dicType: pick(c, ['dicType']),
          dicInfo: pick(c, ['dicInfo'])
        };
      });

      // 已勾选表头字段：统一成字段名字符串数组
      var showFields = (queryConfig.showFields || []).map(function (s) {
        return typeof s === 'string' ? s : pick(s, ['name', 'fieldName']);
      });

      return {
        id: pick(cfg, ['id'], id),
        name: pick(cfg, ['templateName', 'name'], templateName || ''),
        remark: pick(cfg.template, ['remark', 'description'], ''),
        mainTableName: mainTableName,
        mainTableId: mainTableId,
        fields: fields,
        conditions: conditions,
        showFields: showFields,
        operators: Array.isArray(cfg.operators) ? cfg.operators : [],
        sortName: pick(queryConfig, ['sortName'], ''),
        sortType: pick(queryConfig, ['sortType'], ''),
        queryJson: queryConfig
      };
    });
  },

  // 导出查询结果 excel（浏览器下载）
  exportData: function exportData() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var queryJson = payload.queryJson;
    var body = {
      appId: kssAppId || resolveAppId(payload.appId),
      queryJson: typeof queryJson === 'string' ? queryJson : JSON.stringify(queryJson || {})
    };
    if (payload.templateId) {
      body.id = payload.templateId;
    }
    return getStore().dispatch('downloadPostRequest', { url: API_URLS.exportQueryData, params: Qs.stringify(body), responseType: 'blob' }).then(function (data) {
      if (!data) {
        return;
      }
      // 导出失败时后端返回文本/JSON 错误信息
      if ((data.type === 'application/json' || data.type === 'text/plain') && typeof data.text === 'function') {
        return data.text().then(function (msg) {
          throw new Error(msg || '导出失败');
        });
      }
      var url = window.URL.createObjectURL(data);
      var a = document.createElement('a');
      a.href = url;
      a.download = payload.templateName || '自定义查询'; // + '.xls'
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  },

  // 获取查询脚本（标准sql / 调试sql），供"查看脚本"弹窗展示
  getQueryScript: function getQueryScript() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var queryJson = params.queryJson;
    var body = {
      appId: kssAppId || resolveAppId(params.appId),
      queryJson: typeof queryJson === 'string' ? queryJson : JSON.stringify(queryJson || {})
    };
    return getStore().dispatch('postRequest', { url: API_URLS.queryScript, params: body }).then(function (data) {
      if (!data || !data.success) {
        return { success: false, sql: '', debugSql: '', params: [], msg: data && data.msg || '获取脚本失败' };
      }
      // sql/debugSql 直接位于响应根节点，兼容个别嵌套在 data 下的情况
      var d = data.data && (data.data.sql || data.data.debugSql) ? data.data : data;
      return {
        success: true,
        sql: pick(d, ['sql', 'standardSql', 'querySql'], ''),
        debugSql: pick(d, ['debugSql', 'debugSQL', 'debugsql'], ''),
        params: Array.isArray(d.params) ? d.params : []
      };
    });
  },

  // 获取分页选项（从字典 ZD_CUSTOM_PAGEZISE）
  getPageSizeOpts: function getPageSizeOpts() {
    return getStore().dispatch('axiosGetRequest', { url: '/bsp-com/static/dic/bsp/ZD_CUSTOM_PAGEZISE.js' }).then(function (res) {
      if (res && res.data) {
        var fn = eval('(' + res.data + ')');
        var data = fn();
        if (data && data.length > 0) {
          return data.map(function (item) {
            return Number(item.name);
          }).filter(function (v) {
            return !isNaN(v);
          });
        }
      }
      return [10, 20, 50, 100];
    }).catch(function () {
      return [10, 20, 50, 100];
    });
  }
};

export default realApi;


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/custom-query/api/real-api.js
// module id = 80
// module chunks = 0